import { FiUpload, FiHelpCircle } from "react-icons/fi";

const FileUploadButton = ({ onClick, fileInputRef, accept, onShowInstructions, className = "" }) => (
  <>
    <div className={`border-t border-gray-100 ${className}`}>
      <button
        className="flex items-center w-full px-2 py-1 text-xs sm:px-4 sm:py-2 sm:text-sm hover:bg-gray-50 text-gray-700 transition-colors"
        onClick={() => fileInputRef.current.click()}
        type="button"
      >
        <FiUpload className="mr-2 sm:mr-3 w-4 h-4" />
        Import from File
      </button>
      {onShowInstructions && (
        <button
          className="flex items-center w-full px-2 py-1 text-xs sm:px-4 sm:py-2 sm:text-sm hover:bg-gray-50 text-blue-600 border-t border-gray-100 transition-colors"
          onClick={onShowInstructions}
          type="button"
        >
          <FiHelpCircle className="mr-2 sm:mr-3 w-4 h-4" />
          View Instructions
        </button>
      )}
    </div>
    <input
      type="file"
      ref={fileInputRef}
      accept={accept}
      style={{ display: "none" }}
      onClick={e => (e.target.value = null)}
      onChange={onClick}
    />
  </>
);

export default FileUploadButton;